import { ApiQuery, SortDirections, SortQuery } from "~/modules/filters/types";
import { useState } from "react";
import { sortItemsByProperty } from "~/utils/functions/sortItemsByProperty";
import { GigatableColumns, GigatableRow } from "./types";

// // // //

/**
 * GIGATABLE_SORT_MAP
 * Map each AssetColumns to a key used to in-memory sort the array of items using `sortItemsByNestedProperty`
 */
const GIGATABLE_SORT_MAP: Record<GigatableColumns, string> = {
    [GigatableColumns.rank]: "rank",
    [GigatableColumns.name]: "name",
    [GigatableColumns.protocol]: "protocol.name",
    [GigatableColumns.asset_class]: "asset_class.name",
    [GigatableColumns.networks]: "networks",
    [GigatableColumns.value]: "value",
    [GigatableColumns.apy_7d]: "apy_7d",
    [GigatableColumns.pct_change_7d]: "pct_change_7d",
    [GigatableColumns.pct_change_30d]: "pct_change_30d",
    [GigatableColumns.transferable]: "transferable",
};

// // // //

// ENHANCEMENT - update this to accept an optional ApiQuery object for the default query value
export function useInMemoryGigatableSort(props: {
    rows: GigatableRow[];
    sort?: SortQuery;
}) {
    const {
        rows,
        sort = {
            field: GigatableColumns.value,
            direction: SortDirections.desc,
        },
    } = props;

    const [query, setQuery] = useState<ApiQuery>({
        sort,
        pagination: {
            page: 1,
            perPage: 25,
        },
    });

    const sortedItems = sortItemsByProperty({
        items: rows,
        field: GIGATABLE_SORT_MAP[query.sort.field as GigatableColumns],
        direction: query.sort.direction,
        nullsLast: true,
        caseSensitive: false,
    }).map((item, index) => {
        return {
            ...item,
            rank: index + 1,
        };
    });

    return { query, setQuery, sortedItems };
}
